import { useRef, useEffect, useCallback } from "react";
import { useCallbackRef } from "./auth-service-tools566.js";

function useDebouncedCallback(callback, delay) {
  const handleCallback = useCallbackRef(callback);
  const debounceTimerRef = useRef(0);
  useEffect(() => () => window.clearTimeout(debounceTimerRef.current), []);
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    window.clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = window.setTimeout(() => handleCallback(...args), delay);
  }, [handleCallback, delay]);
}

export { useDebouncedCallback };